<template>
    <header class="header container">
        <div class="header__inner">
            <div class="header__left">
                <ZettaLogo />
            </div>
            <nav class="header__nav"
                :class="{'header__nav--opened': burgerMenuIsOpened}"
            >
                <ul class="header__nav-list">
                    <li class="header__nav-item"
                        v-for="link in navLinks"
                        :key="link.text"
                    >
                        <BaseLink :text="link.text"
                            :path="link?.path"
                            :target="link?.target"
                            @click.native="scrollTo(link.name)"    
                        />                 
                    </li>
                </ul>
            </nav>
            <div class="header__contacts">
                <a class="header__contacts-link" href="tel:+78007007707">8 800 700 77 07</a>
                <p class="header__contacts-comment">Горячая линия</p>
            </div>
        </div>
    </header>
</template>

<script>
import ZettaLogo from '@/components/layouts/ZettaLogo.vue';
import BaseLink from '@/components/ui/BaseLink.vue';
import BaseButton from '@/components/ui/BaseButton.vue';
import SvgIcon from '@/components/ui/SvgIcon.vue';
import scrollTo from '@/mixins/scrollTo';

export default {
    name: 'TheHeader',
    components: {
        ZettaLogo,
        BaseLink,
        BaseButton,
        SvgIcon
    },
    mixins: [scrollTo],
    data() {
        return {
            navLinks: [
            ],
            burgerMenuIsOpened: false
        }
    },
}
</script>

<style scoped lang="scss">
.header {    
    &__inner {
        $background-color: $primary-invert;
        $header-height-desktop: 74px;
        $header-height-desktop-min: 74px;

        @include flex-space-between;

        position: relative;

        flex-wrap: wrap;
    
        min-height: rem($header-height-desktop);
        padding: rem($gap-small) rem($gap-big);

        border-radius: rem($border-radius-medium);
        background-color: $background-color;

        @media #{$screen-big} {
            min-height: rem($header-height-desktop-min);
        }
    }

    &__left {
        display: flex;
        align-items: center;
    }

    &__burger-button {
        display: none;

        @media #{$screen-medium} {
            display: inline-block;

            margin-right: rem($gap-medium);
        }
    }

    &__nav {
        $safe-padding: 20px;

        padding-left: rem($safe-padding);
        padding-right: rem($safe-padding);

        @media #{$screen-medium} {
            position: absolute;
            left: 0;
            bottom: rem(-$gap-normal);
            z-index: 1;

            display: none;

            padding: 0;

            transform: translateY(100%);
        }

        &--opened {
            display: block;
        }

        &-list {
            display: flex;
            
            @media #{$screen-medium} {
                flex-direction: column;

                padding: rem($gap-medium);

                border-radius: rem($border-radius-medium);
                background-color: $primary-invert;
                
                transform-origin: top left;
                animation: slide $transition-duration-fast 1;

                @keyframes slide {
                    from {
                        height: 0;
                        transform: scaleY(0);
                    }
                    to {
                        height: auto;
                        transform: scaleY(1);
                    }
                }
            }
        }

        &-item {
            @include list-item-row-margin($gap-big);

            @media #{$screen-big} {
                @include list-item-row-margin($gap-medium);
            }

            @media #{$screen-medium} {
                margin-left: 0;

                & + & {
                    margin-top: rem($gap-normal);
                }
            }
        }
    }

    &__contacts {
        &-link {
            @include text-medium;

            color: $color-text;

            @media #{$screen-big} {
                font-size: rem($font-size-normal);
            }
        }

        &-comment {
            @include text-small;

            margin-top: rem(2px);

            color: $color-text-muted;

            @media #{$screen-big} {
                font-size: rem($font-size-mini);
            }
        }
    }

}
</style>